import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import type { Pantalla } from '@/constants/roles';
import { puedeVer } from '@/constants/roles';

interface RoleRouteProps {
    pantalla: Pantalla;
}

/**
 * Guarda de ruta por rol.
 *
 * El menú lateral ya oculta lo que cada rol no debería ver, pero ocultar no es
 * proteger: sin esta guarda, cualquier usuario logueado entra escribiendo la
 * URL. Ambos leen la misma tabla `ACCESO_PANTALLA`, así que no pueden quedar
 * desalineados.
 *
 * Se monta dentro de ProtectedRoute, que bloquea mientras `isLoading`, así que
 * acá el rol ya está resuelto. Si aun así llegara vacío, `puedeVer` deniega:
 * ante la duda, no mostrar.
 */
export function RoleRoute({ pantalla }: RoleRouteProps) {
    const role = useAuthStore((s) => s.role);

    if (!puedeVer(role, pantalla)) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
}
